var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuspend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 1.66699C5.40511 1.66699 1.66675 5.40536 1.66675 10.0003C1.66675 14.5953 5.40511 18.3337 10.0001 18.3337C14.5951 18.3337 18.3334 14.5953 18.3334 10.0003C18.3334 5.40536 14.5951 1.66699 10.0001 1.66699ZM10.0001 2.91699C11.7334 2.91699 13.2978 3.56011 14.5273 4.58936L4.58911 14.5267C3.5601 13.2973 2.91675 11.7334 2.91675 10.0003C2.91675 6.08091 6.08066 2.91699 10.0001 2.91699ZM15.4111 5.47314C16.4403 6.70264 17.0834 8.26702 17.0834 10.0003C17.0834 13.9197 13.9195 17.0837 10.0001 17.0837C8.267 17.0837 6.70314 16.4403 5.47371 15.4113L15.4111 5.47314Z",
    fill: "#0D5681"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuspend);
export default __webpack_public_path__ + "static/media/suspend.f3b554674da059a25abfcff847daea55.svg";
export { ForwardRef as ReactComponent };